module.exports = __webpack_public_path__ + "static/media/photo4.9421710c.jpg";